import './CategoryFilter.scss';
import Component from './CategoryFilter.js';
export default Component;
